import { reduce } from 'lodash'

const getValue = (stageData, stageName) => stageData.find((m) => m.stage === stageName).count || 0

const normalize = (monthData) => ({
  month: monthData.month_name,
  following: getValue(monthData.by_stage, 'Following'),
  applying: getValue(monthData.by_stage, 'Applying'),
  applied: getValue(monthData.by_stage, 'Applied'),
})

const normalizeMonths = (data) =>
  data && data.by_month
    ? [
        normalize(data.by_month[0]),
        normalize(data.by_month[1]),
        normalize(data.by_month[2]),
        normalize(data.by_month[3]),
        normalize(data.by_month[4]),
        normalize(data.by_month[5]),
        normalize(data.by_month[6]),
        normalize(data.by_month[7]),
        normalize(data.by_month[8]),
        normalize(data.by_month[9]),
        normalize(data.by_month[10]),
        normalize(data.by_month[11]),
        normalize(data.by_month[12]),
      ]
    : []

const getTotals = (data) => {
  if (data && data.by_month) return normalize(data.by_month[12])

  return {
    following: 0,
    applying: 0,
    applied: 0,
  }
}

export const normalizeData = (data) => {
  if (data && data.length > 0) {
    return reduce(
      data,
      (result, monthlyBreakdown) => {
        const gradYear = monthlyBreakdown.grad_year
        const normalized = {
          gradYear,
          months: normalizeMonths(monthlyBreakdown),
          totals: getTotals(monthlyBreakdown),
        }
        result[gradYear] = normalized
        return result
      },
      {},
    )
  }
  return {}
}
